import "@arco-design/web-react/es/Modal/style";
import _Modal from "@arco-design/web-react/es/Modal";
import "@arco-design/web-react/es/Link/style";
import _Link from "@arco-design/web-react/es/Link";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import "@arco-design/web-react/es/Popover/style";
import _Popover from "@arco-design/web-react/es/Popover";
import "@arco-design/web-react/es/Tag/style";
import _Tag from "@arco-design/web-react/es/Tag";
import "@arco-design/web-react/es/Image/style";
import _Image from "@arco-design/web-react/es/Image";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconSearch from "@arco-design/web-react/icon/react-icon/IconSearch";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import React, { useState } from 'react';
import styles from './styles/index.module.less';
import { useHistory } from 'react-router-dom';
import clipboard from '@/utils/clipboard';

function Index() {
  const history = useHistory();
  const [leftList, setLeftList] = useState([{
    name: '全部',
    value: '全部',
    active: true
  }, {
    name: '汽车制造数据',
    value: '汽车制造数据',
    active: false
  }, {
    name: '企业画像数据',
    value: '企业画像数据',
    active: false
  }, {
    name: '互联网数据',
    value: '互联网数据',
    active: false
  }, {
    name: '金融风控',
    value: '金融风控',
    active: false
  }, {
    name: 'OTA数据',
    value: 'OTA数据',
    active: false
  }, {
    name: '房地产数据',
    value: '房地产数据',
    active: false
  }]);
  const initData = [{
    name: '汽车制造数据',
    decs: '汽车制造数据用于优化生产流程，提高产品质量和效率，帮助制造商进行市场需求预测，指导产品设计和改进。',
    value: '汽车制造数据',
    active: false
  }, {
    name: '企业画像数据',
    value: '企业画像数据',
    decs: '企业画像数据帮助企业更精准地了解自身市场定位和竞争状况，从而制定有效的商业策略和市场推广计划。这些数据也为投资者和合作伙伴提供了评估企业实力和潜力的依据。',
    active: false
  }, {
    name: '互联网数据',
    value: '互联网数据',
    decs: '用于分析用户行为、优化产品服务，为企业提供市场动态和用户需求的洞察。这些数据也助于政府和社会机构监测网络舆情、制定相关政策。',
    active: false
  }, {
    name: '金融风控',
    decs: '金融风控数据主要用于评估借款人或企业的信用风险，以便金融机构能够有效管理贷款和投资组合，降低潜在的损失。同时，这些数据帮助金融机构制定合理的信贷政策，保障金融市场的稳定运行。',
    value: '金融风控',
    active: false
  }, {
    name: 'OTA数据',
    decs: '	用于分析和优化旅游产品销售，帮助旅游企业了解市场趋势、调整价格策略和提升服务质量。同时，这些数据也为消费者提供了比较和选择旅游产品的信息，从而做出更合适的预订决策。',
    value: 'OTA数据',
    active: false
  }, {
    name: '房地产数据',
    decs: '用于评估市场趋势、确定房产价值，帮助投资者和开发商做出明智的投资决策。同时，这些数据也为购房者提供了房价走势、地段信息等，以便他们做出合理的购房选择。',
    value: '房地产数据',
    active: false
  }];
  const [cardList, setCardList] = useState(initData);
  const [keyWord, setKeyWord] = useState();

  function handleSearch() {
    setCardList(initData.filter(it => it.name.includes(keyWord)));
  }

  const [visible, setVisble] = useState(false);
  const [p1Active, setP1Active] = useState(false);
  const [p2Active, setP2Active] = useState(false);
  const [p3Active, setP3Active] = useState(false);
  const [p4Active, setP4Active] = useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, "\u82B3\u79BE\u884C\u4E1A\u6570\u636E\u8D44\u4EA7\u76EE\u5F55"), /*#__PURE__*/React.createElement("div", {
    className: styles.inputBox
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.inputText
  }, "\u6570\u636E\u96C6"), /*#__PURE__*/React.createElement(_Input, {
    value: keyWord,
    onChange: val => {
      setKeyWord(val);
    },
    className: styles.input,
    allowClear: true
  }), /*#__PURE__*/React.createElement(_Button, {
    onClick: () => {
      handleSearch();
    },
    icon: /*#__PURE__*/React.createElement(_IconSearch, null),
    className: styles.button,
    type: "primary"
  }, "\u641C\u7D22")), /*#__PURE__*/React.createElement("div", {
    className: styles.cardContent
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.cardLeft
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.leftTop
  }, "\u6570\u636E\u4E3B\u9898"), /*#__PURE__*/React.createElement("div", {
    className: styles.leftTopBar
  }), leftList.map((it, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    onClick: () => {
      setKeyWord('');
      setLeftList(leftList.map((item, index) => ({ ...item,
        active: index === i
      })));

      if (i === 0) {
        setCardList(initData);
      } else {
        setCardList(initData.filter(it2 => it2.value === it.value));
      }
    },
    className: `${styles.leftItem} ${it.active && styles.activeLeftItem}`
  }, /*#__PURE__*/React.createElement("span", null, it.name)))), /*#__PURE__*/React.createElement("div", {
    className: styles.cardright
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rightTop
  }, /*#__PURE__*/React.createElement("span", null, "\u6570\u636E\u96C6")), /*#__PURE__*/React.createElement("div", {
    className: styles.leftTopBar
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.rCardBox
  }, cardList.map(it => /*#__PURE__*/React.createElement("div", {
    key: it.value,
    className: styles.cardItem,
    onClick: () => {
      window.open(location.origin + `/detail?value=${it.value}`);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.cardItemLeft
  }, /*#__PURE__*/React.createElement(_Image, {
    src: require('./img/cardIcon.png'),
    width: 44,
    height: 44
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.cardItemRight
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rightOne
  }, it.name), /*#__PURE__*/React.createElement("div", {
    className: styles.rightTwo
  }, "\u63CF\u8FF0\uFF1A", it.decs), /*#__PURE__*/React.createElement("div", {
    className: styles.rightThree
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.threeText
  }, "\u8D44\u4EA7\u6807\u7B7E\uFF1A"), /*#__PURE__*/React.createElement(_Tag, {
    color: "arcoblue"
  }, it.name))))))))), /*#__PURE__*/React.createElement("div", {
    style: {
      height: 20
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement(_Popover, {
    position: "top",
    content: /*#__PURE__*/React.createElement("div", {
      style: {
        width: 332,
        margin: '0 auto'
      }
    }, /*#__PURE__*/React.createElement(_Image, {
      width: 332,
      height: 347,
      src: require('./img/qrcode.png')
    }))
  }, /*#__PURE__*/React.createElement(_Button, {
    className: styles.footerBtn,
    type: "primary"
  }, "\u7ACB\u5373\u54A8\u8BE2"))), /*#__PURE__*/React.createElement("div", {
    className: styles.sideBox
  }, /*#__PURE__*/React.createElement(_Popover, {
    position: "left",
    content: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      style: {
        color: '#1e1b1b'
      }
    }, "020-8520-7539", /*#__PURE__*/React.createElement(_Link, {
      onClick: () => {
        clipboard('020-8520-7539');

        _Message.success('复制成功!');
      }
    }, "\u590D\u5236")), /*#__PURE__*/React.createElement("div", null, "\u5DE5\u4F5C\u65E5 9:30-18:00"))
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.sideItem,
    onMouseEnter: () => {
      setP1Active(true);
    },
    onMouseLeave: () => {
      setP1Active(false);
    }
  }, p1Active ? /*#__PURE__*/React.createElement(_Image, {
    preview: false,
    width: 64,
    height: 56,
    src: require('./img/p1-a.png')
  }) : /*#__PURE__*/React.createElement(_Image, {
    preview: false,
    width: 64,
    height: 56,
    src: require('./img/p1.png')
  }))), /*#__PURE__*/React.createElement(_Popover, {
    position: "left",
    content: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      style: {
        color: '#1e1b1b'
      }
    }, "sale@fongwell.com", /*#__PURE__*/React.createElement(_Link, {
      onClick: () => {
        clipboard('sale@fongwell.com');

        _Message.success('复制成功!');
      }
    }, "\u590D\u5236")), /*#__PURE__*/React.createElement("div", null, "\u5DE5\u4F5C\u65E5 9:30-18:00"))
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.sideItem,
    onMouseEnter: () => {
      setP2Active(true);
    },
    onMouseLeave: () => {
      setP2Active(false);
    }
  }, p2Active ? /*#__PURE__*/React.createElement(_Image, {
    preview: false,
    width: 64,
    height: 56,
    src: require('./img/p2-a.png')
  }) : /*#__PURE__*/React.createElement(_Image, {
    preview: false,
    width: 64,
    height: 56,
    src: require('./img/p2.png')
  }))), /*#__PURE__*/React.createElement(_Popover, {
    position: "left",
    content: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, "\u6DFB\u52A0\u516C\u4F17\u53F7"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Image, {
      height: 100,
      width: 100,
      src: require('./img/code.png')
    })))
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.sideItem,
    onMouseEnter: () => {
      setP3Active(true);
    },
    onMouseLeave: () => {
      setP3Active(false);
    }
  }, p3Active ? /*#__PURE__*/React.createElement(_Image, {
    preview: false,
    width: 64,
    height: 56,
    src: require('./img/p3-a.png')
  }) : /*#__PURE__*/React.createElement(_Image, {
    preview: false,
    width: 64,
    height: 56,
    src: require('./img/p3.png')
  }))), /*#__PURE__*/React.createElement(_Popover, {
    position: "left",
    content: /*#__PURE__*/React.createElement("div", {
      style: {
        width: 332,
        margin: '0 auto'
      }
    }, /*#__PURE__*/React.createElement(_Image, {
      width: 332,
      height: 347,
      src: require('./img/qrcode.png')
    }))
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.sideItem,
    onMouseEnter: () => {
      setP4Active(true);
    },
    onMouseLeave: () => {
      setP4Active(false);
    }
  }, p4Active ? /*#__PURE__*/React.createElement(_Image, {
    preview: false,
    width: 64,
    height: 56,
    src: require('./img/p4-a.png')
  }) : /*#__PURE__*/React.createElement(_Image, {
    preview: false,
    width: 64,
    height: 56,
    src: require('./img/p4.png')
  })))), /*#__PURE__*/React.createElement(_Modal, {
    visible: visible,
    title: "\u54A8\u8BE2\u6211\u4EEC",
    footer: null,
    onCancel: () => {
      setVisble(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 332,
      margin: '0 auto'
    }
  }, /*#__PURE__*/React.createElement(_Image, {
    width: 332,
    height: 347,
    src: require('./img/qrcode.png')
  }))));
}

export default Index;